import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, timeout } from 'rxjs';
import { ConstantSetterAndGetterService } from '../app.constants';
import { environment } from '../environments/environments';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class CyclopsHttp {
  constructor(
    private http: HttpClient,
    private constantSetterAndGetterService: ConstantSetterAndGetterService
  ) {
    this.baseServerURL = environment.apiUrl;
  }

  baseServerURL = '';
  // this.baseServerURL
  // headers = new HttpHeaders({
  //   'Content-Type': 'application/json',
  //   Authorization:
  //     'bearer ' +
  //     this.constantSetterAndGetterService.getConstants().WEB_API_TOKEN,
  //   organizationId:
  //     this.constantSetterAndGetterService.getConstants().ORGANIZATION_ID,
  //   userId: this.constantSetterAndGetterService.getConstants().USER_ID,
  //   CurrentUrl: window.location.href,
  // });

  private serializeResponse(response: any) {
    if (response.status == 200) {
      const responseObject: any = response.body;
      // if (!responseObject.Error && responseObject.Error != {}) {
      //     return responseObject;
      // } else {
      //     throw response;
      // }
    }
    return response;
  }
  private serializeError(err: any) {
    const status = err.status;
    if (status == 500) {
      throw {
        global: "That's an error. Try again" + 'GlobalError',
        status,
      };
    }
    if (status == 200) {
      const responseObject: any = err.body;
      const { StatusCode, Message } =
        responseObject.Error || responseObject.Errors;
      throw {
        global: `${Message}`,
        status: StatusCode || status,
        StatusCode: StatusCode,
        responseObject: responseObject,
      };
    }
    if (status == 401 || status == 400 || status == 404) {
      const responseObject: any = err.body || err.error;
      if (responseObject) {
        const { Message, message, code, error, StatusCode } = responseObject;
        if (
          (Message &&
            Message.indexOf('Authorization has been denied for this request') >
              -1) ||
          (Message &&
            Message.indexOf('Template not found for organization') > -1) ||
          (error &&
            error.message &&
            error.message.indexOf('one-time offer') > -1) ||
          (error &&
            typeof error === 'string' &&
            error.indexOf('The request does not have clientid specified') >
              -1) ||
          (message && code)
        ) {
          throw {
            global: Message || message || error,
            StatusCode: StatusCode || code,
            status: StatusCode || status,
          };
        } else if (
          responseObject &&
          responseObject?.Error &&
          responseObject?.Error?.StatusCode === 1004
        ) {
          if (
            responseObject?.Error?.Message?.indexOf(
              'The email address already exists for another user.'
            ) > -1
          ) {
            throw {
              global: responseObject?.Error?.Message,
              StatusCode:
                responseObject?.Error?.StatusCode ||
                responseObject?.Error?.code,
              status:
                responseObject?.Error?.StatusCode ||
                responseObject?.Error?.status,
            };
          }
        } else if (
          responseObject?.error?.code &&
          responseObject?.error?.message
        ) {
          throw {
            global: responseObject?.error?.message,
            StatusCode: responseObject?.error?.code,
            status,
          };
        } else {
          throw {
            global: responseObject,
            status,
          };
        }
      }
    }
    if (!status && status !== 0 && err.name === 'TimeoutError') {
      throw {
        global: 'It took longer than expected. Please try again.',
        status,
      };
    }
    if (!status && status === 0 && err?.name === 'HttpErrorResponse') {
      throw {
        global: navigator?.onLine
          ? 'Error while connecting to server.'
          : 'Please check your internet connection and try again.' +
            'InternetError',
        status,
      };
    }
    throw {
      global: "That's an error. Try again",
      status,
    };
  }
  get(url: string, paramsObj?: any, headers?: any) {
    const platform = Capacitor.getPlatform();
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('AccessToken')
          ? localStorage.getItem('AccessToken')
          : this.constantSetterAndGetterService.getConstants().WEB_API_TOKEN,
        CurrentUrl: window.location.href,
        Platform: Capacitor.getPlatform(),
        CurrentTimeZone: currentTimezone,
      }),
    };
    let _params: string = paramsObj ? '?' : null;

    if (_params)
      url = this.baseServerURL + `${url}${_params}${'id='}${paramsObj}`;
    else url = this.baseServerURL + `${url}`;
    return this.http.get(url, httpOptions).pipe(
      timeout(this.constantSetterAndGetterService.getConstants().TIMEOUT),
      map((response: any) => {
        return this.serializeResponse(response);
      }),
      catchError((err: Error): any => {
        return this.serializeError(err);
      })
    );
  }
  post(url: string, params?: any, headers?: any) {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('AccessToken')
          ? localStorage.getItem('AccessToken')
          : this.constantSetterAndGetterService.getConstants().WEB_API_TOKEN,
        CurrentUrl: window.location.href,
        Platform: Capacitor.getPlatform(),
        CurrentTimeZone: currentTimezone,
      }),
    };
    url = this.baseServerURL + url;
    return this.http
      .post(url, params || null, {
        headers: httpOptions.headers,
        responseType: 'text',
      })
      .pipe(
        timeout(
          this.constantSetterAndGetterService.getConstants().POSTCALL_TIMEOUT
        ),
        map((response: any) => {
          return this.serializeResponse(response);
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  put(url: string, params?: any, headers?: any) {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    url = this.baseServerURL + url;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('AccessToken')
          ? localStorage.getItem('AccessToken')
          : this.constantSetterAndGetterService.getConstants().WEB_API_TOKEN,
        CurrentUrl: window.location.href,
        CurrentTimeZone: currentTimezone,
      }),
    };
    return this.http
      .put(url, params || null, {
        headers: httpOptions.headers,
        responseType: 'text',
      })
      .pipe(
        timeout(this.constantSetterAndGetterService.getConstants().TIMEOUT),
        map((response: any) => {
          return this.serializeResponse(response);
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  delete(url: string, params?: any, headers?: any) {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    url = this.baseServerURL + url;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('AccessToken')
          ? localStorage.getItem('AccessToken')
          : this.constantSetterAndGetterService.getConstants().WEB_API_TOKEN,
        CurrentUrl: window.location.href,
        CurrentTimeZone: currentTimezone,
      }),
    };
    return this.http
      .delete(url, {
        headers: httpOptions.headers,
        params: params || null,
        responseType: 'text',
      })
      .pipe(
        timeout(this.constantSetterAndGetterService.getConstants().TIMEOUT),
        map((response: any) => {
          return this.serializeResponse(response);
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
}
